module.exports = __webpack_public_path__ + "img/-h-footer_logo.3b0e0179.png";